import React, { useEffect, useRef, useState } from 'react'
import './org-invites.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import Modal, { ModalConfirm } from '@/components/modal/modal.component';
import { properCase } from '@/utils/properCase';
import { format } from 'date-fns';
import { UseCloudFunction } from '@/utils/firebase.utils';
import { useSelector } from 'react-redux';
import FullPageLoader from '@/components/loader/full-page-loader.component';
import OrgInviteModal from '@/components/HOME/orgs/org-invite-modal/org-invite-modal.component';

const OrgInvites = ({ orgData, invites }) => {

    const userProfile = useSelector(state => state.userData.userProfile);
    const [ showInviteModal, setShowInviteModal ] = useState(false);
    const [ invitesToDisplay, setInvitesToDisplay ] = useState(null);
    const [ activeToDisplay, setActiveToDisplay ] = useState(null);
    const [ confirmMessage, setConfirmMessage ] = useState(null);
    const approveRef = useRef();

    useEffect(() => {
        console.log(invites);
        if (!invites) return;
        const sortedPendingInvites = Object.values(invites)
        .filter(i => i.status !== 'accepted')
        .sort((a,b) => a.email > b.email ? 1 : -1)
        setInvitesToDisplay([...sortedPendingInvites]);
        const sortedActiveInvites = Object.values(invites)
        .filter(i => i.status === 'accepted')
        .sort((a,b) => a.email > b.email ? 1 : -1)
        setActiveToDisplay([...sortedActiveInvites]);
    }, [invites])

    function removeActiveUser(id) {
        setConfirmMessage('Are you sure you want to remove this user? Removing this user from the organization will also remove their access to games within the organization that they do not own. This action will free up a user slot, and it cannot be undone.');
        approveRef.current = () => {
            continueRemove();
        }

        async function continueRemove() {
            const res = await UseCloudFunction(
                'removeActiveUser', 
                {
                    'orgId': orgData.orgId, 
                    'userId': id, 
                    'email': userProfile.email
                })
            if (res.success) {
                setConfirmMessage(null);
            } else {
                setConfirmMessage('There was an error removing the user. Please try again.');
            }
        }
    }

    return (
        <div className='org-invites'>
            <div className='with-icon'>
                <h3>Invited Users</h3>
                <button 
                    className='g-button med-btn'
                    onClick={() => setShowInviteModal(true)}
                >
                    <FontAwesomeIcon icon={faPlusCircle} />
                </button>
            </div>
            <div className='meta'>Member Count: {orgData.memberCount}/{orgData.memberMax}</div>
            <div className="g-space-1"></div>
            <h4>Active Members</h4>
            <div className='invite-list'>
                <div className='g-list-item invite-list-item head'>
                    <div></div>
                    <div>Email</div>
                    <div className='meta'>Status</div>
                    <div className='meta'>Invited</div>
                    <div className='meta'>Accepted</div>
                    <div className='buttons'></div>
                </div>
            {
                (activeToDisplay) &&
                activeToDisplay.map((i, index) => (
                    <div key={i.id} className='g-list-item invite-list-item'>
                        <div>{index+1}</div>
                        <div>{i.email}</div>
                        <div className='meta'>{properCase(i.status)}</div>
                        <div className='meta'>{format(new Date(i.ts_created), "P")}</div>
                        <div className='meta'>{i.ts_accepted ? format(new Date(i.ts_accepted), "P") : ''}</div>
                        <div className='buttons'>
                            <button 
                                className='g-button tiny-btn'
                                onClick={() => removeActiveUser(i.id)}>
                                Remove
                            </button>
                        </div>
                    </div>
                ))
            }
            </div>
            <div className='g-space-1'></div>
            <h4>Pending/Declined Invites</h4>
            
            <div className='invite-list'>
                <div className='g-list-item invite-list-item head'>
                    <div></div>
                    <div>Email</div>
                    <div className='meta'>Status</div>
                    <div className='meta'>Invited</div>
                    <div className='meta'>Declined</div>
                    <div className='buttons'></div>
                </div>
            {
                (invitesToDisplay) &&
                invitesToDisplay.map((i, index) => (
                    <div key={i.id} className='g-list-item invite-list-item'>
                        <div>{index+1}</div>
                        <div className='email'>{i.email}</div>
                        <div className='meta'>{properCase(i.status)}</div>
                        <div className='meta'>{format(new Date(i.ts_created), "P")}</div>
                        <div className='meta'>{i.ts_declined ? format(new Date(i.ts_declined), "P") : ''}</div>
                        <div className='buttons'>
                            {
                                (!i.ts_declined) &&
                                <button className='g-button tiny-btn'>Cancel</button>
                            }
                        </div>
                    </div>
                ))
            }
            </div>
            <OrgInviteModal
                show={showInviteModal}
                cancel={() => setShowInviteModal(false)}
                orgData={orgData}
                invites={invites} />
            <ModalConfirm
                show={confirmMessage}
                cancel={() => setConfirmMessage(null)}
                message={confirmMessage}
                onApprove={approveRef.current} />
        </div>
    )
}

export default OrgInvites